<div class="sensor-installation-select">
  @if (value) {
    <div class="linked-sensor">
      <nb-icon pack="fas" icon="tower-broadcast" [ngStyle]="{ color: value.color }"></nb-icon>
      <div class="sensor-info">
        <span class="sensor-name">{{ value.name }}</span>
        <span class="block-name">{{ value.sensorBlockName }}</span>
      </div>
      @if (!isDisabled) {
        <button nbButton ghost status="danger" type="button" (click)="removeSensor()">
          <nb-icon pack="eva" icon="close-outline"></nb-icon>
        </button>
      }
    </div>
  } @else if (isDisabled) {
    <span class="no-sensor">Kein Sensor verknüpft</span>
  } @else {
    <button
      nbButton
      ghost
      type="button"
      class="link-sensor"
      [nbPopover]="sensorPopover"
      [nbPopoverPlacement]="NbPosition.RIGHT">
      <nb-icon pack="eva" icon="plus-outline"></nb-icon>
      <span>Sensor verknüpfen</span>
    </button>
  }
</div>

<ng-template #sensorPopover>
  <div class="sensor-select-popover">
    <input
      nbInput
      fullWidth
      placeholder="Sensor suchen..."
      [value]="searchText$ | async"
      (input)="onSearchChange($any($event.target).value)">
    <nb-list class="sensor-options">
      @for (sensor of sensors$ | async; track sensor.id) {
        <nb-list-item class="sensor-option" (click)="selectSensor(sensor)">
          <nb-icon pack="fas" icon="tower-broadcast" [ngStyle]="{ color: sensor.color }"></nb-icon>
          <div class="sensor-option-info">
            <span class="sensor-name">{{ sensor.name }}</span>
            <span class="block-name">{{ sensor.sensorBlockName }}</span>
          </div>
          @if (showPurpose()) {
            <span class="purpose-chip">{{ sensor.purpose | sensorPurpose }}</span>
          }
        </nb-list-item>
      }
      @if ((sensors$ | async)?.length === 0) {
        <nb-list-item class="no-results">Keine Sensoren gefunden</nb-list-item>
      }
    </nb-list>
  </div>
</ng-template>
